<img ngxGravatar [email]="email?.length > 0 ? email : 'email-not-found'" [size]="size"
    [src]="base64?.length > 0 ? base64 : null" [fallback]="fallback" />
